import { render, staticRenderFns } from "./MediaFile.vue?vue&type=template&id=531fe298&scoped=true&"
import script from "./MediaFile.vue?vue&type=script&lang=js&"
export * from "./MediaFile.vue?vue&type=script&lang=js&"
import style0 from "./MediaFile.vue?vue&type=style&index=0&id=531fe298&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531fe298",
  null
  
)

export default component.exports